<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        class="py-0"
        style="font-weight: bold; text-align: center;"
      >
        {{ name }}{{ gender }}
      </v-col>
      <v-col cols="12" class="py-0" style="text-align: center;">
        {{ birthday }}{{ age }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GetUserDetails } from "@/store/registration";

export default {
  name: "UserInfo",

  props: {
    code: String
  },

  data: () => ({
    name: "",
    image: "",
    age: "",
    birthday: "",
    gender: ""
  }),

  methods: {
    getGender(gender) {
      if (gender) {
        if ("M" === gender) {
          return " (MALE)";
        } else if ("F" === gender) {
          return " (FEMALE)";
        }
      }

      return "";
    }
  },

  watch: {
    code() {
      GetUserDetails(this.code).then(details => {
        this.name = details.firstname
          ? `${details.firstname} ${details.lastName}`
          : "";
        this.age = details.age ? ` (${details.age})` : "";
        this.birthday = details.birthday || "";
        this.gender = this.getGender(details.gender);
      });
    }
  }
};
</script>
